<template>
  <section class="mx-auto flex min-h-[70vh] max-w-3xl flex-col gap-6 px-6 py-16">
    <div class="rounded-3xl border border-white/10 bg-midnight-800/60 p-6 shadow-glow sm:p-8">
      <div class="flex flex-col gap-2">
        <p class="text-xs uppercase tracking-[0.35em] text-steel-400">{{ $t('report.eyebrow') }}</p>
        <h1 class="font-display text-3xl font-semibold text-white">{{ $t('report.title') }}</h1>
        <p class="text-sm text-steel-300">
          {{ $t('report.description') }}
        </p>
      </div>

      <form class="mt-6 space-y-5" @submit.prevent="submitReport">
        <label class="block text-sm text-steel-200">
          {{ $t('report.category') }}
          <select
            v-model="category"
            class="mt-2 w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"
          >
            <option value="bug">{{ $t('report.bug') }}</option>
            <option value="performance">{{ $t('report.performance') }}</option>
            <option value="ui">{{ $t('report.ui') }}</option>
            <option value="account">{{ $t('report.account') }}</option>
            <option value="other">{{ $t('report.other') }}</option>
          </select>
        </label>

        <label class="block text-sm text-steel-200">
          {{ $t('report.whatHappened') }}
          <textarea
            v-model.trim="description"
            rows="6"
            maxlength="1000"
            :placeholder="$t('report.descriptionPlaceholder')"
            class="mt-2 w-full resize-none rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-500 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"
          ></textarea>
        </label>

        <label class="block text-sm text-steel-200">
          {{ $t('report.pageUrl') }}
          <input
            v-model.trim="pageUrl"
            type="text"
            class="mt-2 w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-500 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"
            placeholder="https://"
          />
        </label>

        <div class="flex flex-wrap items-center gap-3">
          <button
            type="submit"
            class="rounded-2xl bg-white px-6 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-400 disabled:cursor-not-allowed disabled:opacity-70"
            :disabled="submitting || !description"
          >
            {{ submitting ? $t('report.submitting') : $t('report.submit') }}
          </button>
          <p v-if="statusMessage" class="text-sm text-neon-300">{{ statusMessage }}</p>
          <p v-if="errorMessage" class="text-sm text-rose-200">{{ errorMessage }}</p>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { supabase, getReadySession } from '@/lib/supabase'

export default {
  name: 'ReportIssueView',
  data() {
    return {
      userId: '',
      category: 'bug',
      description: '',
      pageUrl: '',
      submitting: false,
      statusMessage: '',
      errorMessage: '',
    }
  },
  async mounted() {
    const user = (await getReadySession())?.user
    if (!user) {
      this.$router.push('/login')
      return
    }
    this.userId = user.id
    this.pageUrl = window.location.href
  },
  methods: {
    async submitReport() {
      if (!this.userId) {
        this.errorMessage = this.$t('report.signInRequired')
        return
      }
      if (!this.description) return

      this.submitting = true
      this.errorMessage = ''
      this.statusMessage = ''

      const { error } = await supabase.from('site_reports').insert({
        user_id: this.userId,
        category: this.category,
        description: this.description,
        page_url: this.pageUrl,
        status: 'open',
      })

      this.submitting = false

      if (error) {
        this.errorMessage = error.message || this.$t('report.submitError')
        return
      }

      this.description = ''
      this.statusMessage = this.$t('report.sent')
      setTimeout(() => (this.statusMessage = ''), 2500)
    },
  },
}
</script>
